import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import MovieCard from '../../components/MovieCard/MovieCard';
import { APIURLContext } from '../../contexts/APIURLContext';
import { Dropdown } from 'react-bootstrap'; // Import Dropdown from react-bootstrap
import './HomePage.css'
import {Spinner} from 'react-bootstrap';

function Homepage() {
    const [movies, setMovies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedGenre, setSelectedGenre] = useState('All'); // State to store selected genre
    const apiURL = useContext(APIURLContext); 

    useEffect(() => {
        const getRandomMovies = async () => {
            setLoading(true);
            try {
                let url = `${apiURL}/random-movies`;
                if (selectedGenre !== 'All') {
                    // Append selected genre to the API URL if a genre is selected
                    url += `?genre=${selectedGenre}`;
                }
                const response = await axios.get(url);
                setMovies(response.data);
            } catch (error) {
                console.error('Error fetching movies:', error);
            }
            setLoading(false);
        };
        getRandomMovies();
    }, [apiURL, selectedGenre]); // Add selectedGenre as a dependency

    // Function to handle genre selection
    const handleGenreSelect = (genre) => {
        setSelectedGenre(genre);
    };

    return (
        <div className="container">
            <h1>Featured Movies</h1>
            <Dropdown>
                <Dropdown.Toggle variant="danger">
                    Select Genre: {selectedGenre}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleGenreSelect('All')}>All</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleGenreSelect('Horror')}>Horror</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleGenreSelect('Action')}>Action</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleGenreSelect('Drama')}>Drama</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleGenreSelect('Romance')}>Romance</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleGenreSelect('Science Fiction')}>Science Fiction</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleGenreSelect('Comedy')}>Comedy</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleGenreSelect('Thriller')}>Thriller</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleGenreSelect('Animated')}>Animated</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            {loading ? (
              <div className="spinner-container">
              <Spinner animation="border" variant="danger"/>
          </div>
            ) : (
          <div className="card-deck">
              <div className="d-flex flex-wrap justify-content-center">
                  {movies.map((movie) => (
                      <div className="col" key={movie._id}>
                          <MovieCard movie={movie} />
                      </div>
                  ))}
              </div>
          </div>
            )}
     </div>
    );
}

export default Homepage;
